module.exports = __webpack_public_path__ + "img/mauritius.475af446.svg";